export default __webpack_public_path__ + "static/media/Theme16.c4ec9fa5.png";